import { TachoModuleConsts } from 'tacho-models';
import {
    paymentStatusEnumTranslationsEn,
    paymentStatusEnumTranslationsPl,
} from '../../../core/domainModels/licences/PaymentStatus';
import {
    licenseStatusEnumTranslationsEn,
    licenseStatusEnumTranslationsPl,
} from '../../../core/domainModels/licences/LicenseStatus';
import { licenseTypeEnumTranslationsEn, licenseTypeEnumTranslationsPl } from '../../../core/domainModels/licences/LicenseType';

export const licencesPageTranslationsPl = {
    licencesAddButton: 'Licencje',
    licencesVersionAddButton: 'Wersje',
    licencesPage: 'Licencje',
    licencesPageGenerate: 'Wygeneruj',
    licencesPageGenerateLicence: 'Wygeneruj licencję',
    licencesPageUpdateLicence: 'Aktualizuj licencję',
    licencesPaymentStatus: 'Status płatności',
    licencesDistributor: 'Dystrubutor',
    licencesLicenseType: 'Typ licencji',
    licencesClientId: 'ID klienta',
    licencesVersionCount: 'Liczba wersji',
    licencesMaximumNumberOfSupportedCars: 'Liczba aktywnych samochodów',
    licencesAvailableCarStatusChanges: 'Dostępne zmiany statusów samochodów',
    licencesNoCarsLimit: 'Bez limitu (full)',
    licencesIncludeBeta: 'Załącz wersje beta',
    licencesNumberOfCars: 'Pojazdy',
    licencesValidTo: 'Aktualizacja do',
    licencesValidFrom: 'Aktualizacja od',
    licencesNumber: 'Nr licencji',
    licencesRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć wybraną licencje?',
    licencesVersionRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć ostatnią wersję aktualizacji?',
    licenceDeleteTitle: 'Usuń licecję',
    licenceVersionDeleteTitle: 'Usuń aktualizację licecji',
    licencesSendLicenceToTheClientEmail: 'Wysyłanie licencji na adres e-mail',
    licencesSendLicenceSuccess: 'Poprawnie wysłano licencję',
    licencesAllowedModules: 'Dozwolone moduły i liczba stanowisk',
    licencesClient: 'Klient',
    licencesEmail: 'Adres e-mail',
    licenceDownload: 'Pobierz licencję',
    licenceSend: 'Wyślij licencję na e-mail',
    licenceSendButton: 'Wyślij',
    licencesIsServiceEdition: 'Wersja usługowa',
    licencesPaymentDeadline: 'Termin płatności',
    licencesUpdatesAvailableUntil: 'Aktualizacje dostępne do',
    licencesGenerateNewVersion: 'Generuj nową wersje',
    licencesAnex: 'Aktualizacja',
    licenceNumberId: 'Id licencji',
    licenceStatusChange: 'Zmień status',
    licenceStatus: 'Status',
    licenceVersionAdd: 'Dodaj wersje licencji',
    licenceAllowCarStatusCounterReset: 'Reset liczby zmian statusu pojazdu',
    licenceVersionsCannotOverlap: 'Aktualizację licencji nie mogą się nakładać',
    licenceVersionsMustBeContinuous:
        'Aktualizacje muszą być ciągłe - kolejna musi zaczynać się dzień po zakończeniu poprzedniej (np. 31 sty - 1 lut)',
    licenceBeforeFirstValidFrom: 'Nie można utworzyć aktualizacji przed innymi',
    licenceBeforeFirstValidTo: 'Nie można utworzyć aktualizacji za innymi',
    licenceCarsFull: '(full)',
    licenceEmptyClient: 'Klient musi zostać wybrany',
    licenceEmptyOrWrongDate: 'Nieprawidłowa data',
    licenceAllowedModulesError: 'Brak wybranych modułów',
    licenceEmptyDistributor: 'Dystrybutor musi zostać wybrany',
    licenceEditClient: 'Edytuj dane klienta',
    licenceShowVersions: 'Pokaż wersje',
    licencesTokenValidFrom: 'Token ważny od',
    licencesTokenVersion: 'Wersja z tokena',
    [TachoModuleConsts.violationsModuleId.toLowerCase()]: 'Naruszenia',
    [TachoModuleConsts.recordsModuleId.toLowerCase()]: 'Ewidencja + Delegacje',
    [TachoModuleConsts.foreignRecordsModuleId.toLowerCase()]: 'Płace zagraniczne',
    ...paymentStatusEnumTranslationsPl,
    ...licenseStatusEnumTranslationsPl,
    ...licenseTypeEnumTranslationsPl,
};
export const licencesPageTranslationsEn = {
    licencesAddButton: 'Licence',
    licencesVersionAddButton: 'Version',
    licencesPage: 'Licences',
    licencesPageGenerate: 'Generate',
    licencesPageGenerateLicence: 'Generate licence',
    licencesPageUpdateLicence: 'Update licence',
    licencesPaymentStatus: 'Payment status',
    licencesDistributor: 'Distributor',
    licencesLicenseType: 'License type',
    licencesClientId: 'Client ID',
    licencesVersionCount: 'Number of versions',
    licencesMaximumNumberOfSupportedCars: 'Number of active cars',
    licencesAvailableCarStatusChanges: 'Available car status changes',
    licencesNumberOfCars: 'Cars',
    licencesNoCarsLimit: 'Unlimited (full)',
    licencesIncludeBeta: 'Include beta versions',
    licencesValidTo: 'Valid to',
    licencesValidFrom: 'Valid from',
    licencesNumber: 'Licence nr',
    licencesRemoveConfirmationMessage: 'Are you sure you want to delete the selected licence?',
    licencesVersionRemoveConfirmationMessage: 'Are you sure you want to delete the last version?',
    licenceDeleteTitle: 'Delete licence',
    licenceVersionDeleteTitle: 'Delete licence version',
    licencesSendLicenceToTheClientEmail: 'Sending licence to client e-mail',
    licencesSendLicenceSuccess: 'Licence successfully sent',
    licencesAllowedModules: 'Allowed modules',
    licencesClient: 'Client',
    licencesEmail: 'E-mail',
    licenceDownload: 'Download licence',
    licenceSend: 'Send licence to e-mail',
    licenceSendButton: 'Send',
    licencesIsServiceEdition: 'Service edition',
    licencesPaymentDeadline: 'Payment deadline',
    licencesUpdatesAvailableUntil: 'Updates available until',
    licencesGenerateNewVersion: 'Generate new version',
    licencesAnex: 'Update',
    licenceNumberId: 'Licence ID',
    licenceStatusChange: 'Change status',
    licenceStatus: 'Status',
    licenceVersionAdd: 'Add licence version',
    licenceAllowCarStatusCounterReset: 'Car status counter reset',
    licenceVersionsCannotOverlap: 'Licence versions cannot overlap',
    licenceVersionsMustBeContinuous:
        'Licence versions must be continuous - the next must start the day after the previous ends (e.g. Jan 31 - Feb 1)',
    licenceBeforeFirstValidFrom: 'Licence version cannot be updated before existing others',
    licenceBeforeFirstValidTo: 'Licence version cannot be updated after existing others',
    licenceCarsFull: '(full)',
    licenceEmptyClient: 'Client must be selected',
    licenceEmptyOrWrongDate: 'Wrong date',
    licenceAllowedModulesError: 'No modules selected',
    licenceEmptyDistributor: 'Distributor must be selected',
    licenceEditClient: 'Edit client data',
    licenceShowVersions: 'Show versions',
    licencesTokenValidFrom: 'Token valid from',
    licencesTokenVersion: 'Version from token',
    [TachoModuleConsts.violationsModuleId.toLowerCase()]: 'Violations',
    [TachoModuleConsts.recordsModuleId.toLowerCase()]: 'Records and Delegations',
    [TachoModuleConsts.foreignRecordsModuleId.toLowerCase()]: 'Foreign records',
    ...paymentStatusEnumTranslationsEn,
    ...licenseStatusEnumTranslationsEn,
    ...licenseTypeEnumTranslationsEn,
};
